export const GENERIC_ERROR_MESSAGE =
  "Failed - Due to Technical error, Please try again";

/**
 * action type constants related to fetching the enrolled devices based on a search text
 */
export const SEARCH_DEVICES_REQUEST = "SEARCH_DEVICES_REQUEST";
export const SEARCH_DEVICES_SUCCESS = "SEARCH_DEVICES_SUCCESS";
export const SEARCH_DEVICES_ERROR = "SEARCH_DEVICES_ERROR";

/**
 * action type constants related to fetching the enrolled devices in a particular instrument group
 */
export const INST_GROUP_DEVICES_FETCH_REQUEST =
  "INST_GROUP_DEVICES_FETCH_REQUEST";
export const INST_GROUP_DEVICES_FETCH_SUCCESS =
  "INST_GROUP_DEVICES_FETCH_SUCCESS";
export const INST_GROUP_DEVICES_FETCH_ERROR = "INST_GROUP_DEVICES_FETCH_ERROR";

/**
 * action type constants related to adding enrolled device in a particular instrument group
 */
export const ADD_INST_TO_INST_GRP_REQUEST = "ADD_INST_TO_INST_GRP_REQUEST";
export const ADD_INST_TO_INST_GRP_SUCCESS = "ADD_INST_TO_INST_GRP_SUCCESS";
export const ADD_INST_TO_INST_GRP_ERROR = "ADD_INST_TO_INST_GRP_ERROR";

export const REMOVE_INST_FROM_INSTS_TO_REMOVE_IN_GRP_LIST =
  "REMOVE_INST_FROM_INSTS_TO_REMOVE_IN_GRP_LIST";

export const CLOSE_ADD_INST_TO_GRP_ERR_POPUP =
  "CLOSE_ADD_INST_TO_GRP_ERR_POPUP";

/**
 * action type constants related to removing enrolled device from a particular instrument group
 */
export const REMOVE_INST_FROM_INST_GRP = "REMOVE_INST_FROM_INST_GRP";

export const INST_ALREADY_EXISTS_IN_GRP_MSG =
  "Instrument already exists in the selected instrument group";
export const INST_ALREADY_ADDED_FOR_SAVING_IN_GRP_MSG =
  "Instrument is already added for saving in the selected instrument group";

export const SAVE_INST_GRP_MAP_REQUEST = "SAVE_INST_GRP_MAP_REQUEST";
export const SAVE_INST_GRP_MAP_SUCCESS = "SAVE_INST_GRP_MAP_SUCCESS";
export const SAVE_INST_GRP_MAP_ERROR = "SAVE_INST_GRP_MAP_ERROR";

export const CLOSE_INST_GRP_MAP_MSG = "CLOSE_INST_GRP_MAP_MSG";

export const CANCEL_INST_GROUP_MAP = "CANCEL_INST_GROUP_MAP";

export const RESET_INST_GRP_STATE = "RESET_INST_GRP_STATE";
